export const note = () => ({
    maxWidth: 735,
});
